var map = {
	"./Bootstrap.svg": 4423,
	"./Brush.svg": 8399,
	"./Bug.svg": 9132,
	"./Code.svg": 698,
	"./Github.svg": 5906,
	"./Hearth.svg": 3115,
	"./Instagram.svg": 4064,
	"./Laravel.svg": 593,
	"./React.svg": 2868,
	"./Tailwind.svg": 9856,
	"./Tiktok.svg": 2798,
	"./Translate.svg": 6712,
	"./WaveAnimation.svg": 3699,
	"./Whatsapp.svg": 7559,
	"./World.svg": 2212,
	"./Youtube.svg": 9547,
	"./moon-fill.svg": 7474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;